<template>
    <div>
        <b-card no-body header="Payment Cancelled" v-if="data.cancelledDateTimeUTC != null">
            <b-list-group flush>
                <b-list-group-item>
                    <div><b>Cancelled:</b>&nbsp;{{ formatDateTime(data.cancelledDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}</div>
                    <div><b>Cancelled By:</b>&nbsp;{{ data.cancelledByUserAccountName }}</div>
                </b-list-group-item>
            </b-list-group>
        </b-card>
        <b-card no-body header="Payment Submissions" v-if="(data.paymentSubmissions != null) && (data.paymentSubmissions.length > 0) && (data.cancelledDateTimeUTC == null)">
            <b-list-group flush>
                <b-list-group-item v-for="paymentSubmission in data.paymentSubmissions" :key="paymentSubmission.paymentSubmissionId">
                    <div><b>Reference:</b>&nbsp;{{ paymentSubmission.paymentReference }}</div>
                    <div><b>Created:</b>&nbsp;{{ formatDateTime(paymentSubmission.createdDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}</div>
                    <div v-if="paymentSubmission.submittedDateTimeUTC"><b>Submitted:</b>&nbsp;{{ formatDateTime(paymentSubmission.submittedDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}</div>
                    <div v-if="paymentSubmission.processedDateTimeUTC"><b>Processed:</b>&nbsp;{{ formatDateTime(paymentSubmission.processedDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}</div>
                    <div><b>Status:</b>&nbsp;<span :class="(paymentSubmission.paymentSucceeded ? 'text-success' : 'text-danger')">{{ paymentSubmission.status }}</span></div>
                    <div v-if="paymentSubmission.paymentErrorMessage"><b>Error:</b>&nbsp;{{ paymentSubmission.paymentErrorMessage }}</div>
                </b-list-group-item>
            </b-list-group>
        </b-card>
        <b-card no-body header="Refunds" v-if="(data.refunds != null) && (data.refunds.length > 0) && (data.cancelledDateTimeUTC == null)">
            <b-list-group flush>
                <b-list-group-item v-for="refund in data.refunds" :key="refund.refundId">
                    <div><b>Reference:</b>&nbsp;{{ refund.paymentReference }}</div>
                    <div><b>Amount:</b>&nbsp;{{ formatAsCurrency(refund.amount) }}</div>
                    <!--<div><b>Bank Charges:</b>&nbsp;{{ formatAsCurrency(refund.bankCharges) }}</div>-->
                    <div><b>{{ $t("Shared.Label.GST") }} Amount:</b>&nbsp;{{ formatAsCurrency(refund.gstAmount) }}</div>
                    <div><b>Total Amount:</b>&nbsp;{{ formatAsCurrency(refund.totalAmount) }}</div>
                    <div><b>Created:</b>&nbsp;{{ formatDateTime(refund.createdDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}&nbsp;<b>by</b>&nbsp;{{ refund.createdByUserAccount }}</div>
                    <div v-if="refund.processedDateTimeUTC"><b>Processed:</b>&nbsp;{{ formatDateTime(refund.processedDateTimeUTC, 'DD/MM/YYYY hh:mmA', true, false) }}</div>
                    <div><b>Status:</b>&nbsp;<span :class="(refund.processingSucceeded ? 'text-success' : 'text-danger')">{{ refund.status }}</span></div>
                    <div v-if="refund.processingErrorMessage"><b>Error:</b>&nbsp;{{ refund.processingErrorMessage }}</div>
                </b-list-group-item>
            </b-list-group>
        </b-card>
    </div>
</template>

<script>
    import DateTimeMixin from '../../mixins/DateTimeMixin';
    import NumbersMixin from '../../mixins/NumbersMixin';

    export default {
        name: 'PaymentsGridDetailsRow',
        mixins: [DateTimeMixin,NumbersMixin],
        data() {
            //public interface
            return {
                data: {}
            }
        },
        computed: {
          //
        },
        methods: {
          //
        },
        watch: {
            //
        },

        //Life-cycle hooks  ---------- ---------- ---------- ---------- ----------
        beforeCreate() {
          //
        },
        created() {
          //
        },
        beforeMount() {
          //
        },
        mounted() {
          //
        },
        beforeUpdate() {
          //
        },
        updated() {
          /*
          this.$nextTick(function () {
            // Code that will run only after the
            // entire view has been re-rendered
          });
          */
        },
        /*
        activated() {
          //
        },
        deactivated() {
          //
        },

        beforeDestroy() {
          //
        },
        destroyed() {
          //
        },
        errorCaptured() {
          console.log(...arguments);
          return false;
        }
        */
    }
</script>


